export const CLAIM_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

export function validateClaimImageFile(file: File): string | null {
  if (!file.type.startsWith('image/')) {
    return 'Please choose an image file.';
  }
  if (file.size > CLAIM_IMAGE_MAX_BYTES) {
    return 'Image must be 10 MB or smaller.';
  }
  return null;
}
